import { createReducer } from 'utils/ReduxUtils';

import * as actionTypes from '../../actionTypes';

const initialState = null;

const clearError = () => null;
const hasError = (_, { payload }) => payload.message;

export default createReducer(initialState, {
  [actionTypes.FETCH_APPOINTMENTS_REQUEST]: clearError,
  [actionTypes.FETCH_APPOINTMENT_REQUEST]: clearError,
  [actionTypes.DELETE_REQUEST]: clearError,
  [actionTypes.PATCH_STATUS_REQUEST]: clearError,
  [actionTypes.POST_REQUEST]: clearError,
  [actionTypes.PUT_REQUEST]: clearError,
  [actionTypes.FETCH_APPOINTMENTS_FAILURE]: hasError,
  [actionTypes.FETCH_APPOINTMENT_FAILURE]: hasError,
  [actionTypes.DELETE_FAILURE]: hasError,
  [actionTypes.PATCH_STATUS_FAILURE]: hasError,
  [actionTypes.POST_FAILURE]: hasError,
  [actionTypes.PUT_FAILURE]: hasError,
});
